export default "__VITE_ASSET__BnHEWFGB__"